import { render } from "./Tag.vue?vue&type=template&id=29a7bcf2&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=29a7bcf2&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a7bcf2"]])

export default __exports__